import React from 'react';

import Pocket from '../../../components/DataTable/PocketDataTable';

const COLUMNS = [
    { type: 'important' },
    {
        type: 'title',
        accessor: 'name',
    },
    {
        type: 'text',
        title: 'URL',
        accessor: 'url',
    },
    { type: 'edit' },
    { type: 'delete' },
];

const FORM_FIELDS = [
    {
        type: 'input',
        name: 'name',
        label: 'Название',
        isRequired: true,
    },
    {
        type: 'textarea',
        name: 'descr',
        label: 'Описание',
        textareaRows: 4,
    },
    {
        type: 'input',
        name: 'url',
        label: 'URL',
        isRequired: true,
    },
    {
        type: 'input',
        name: 'pixel',
        label: 'Пиксель',
    },
    {
        type: 'image',
        name: 'picture',
        label: 'Изображение',
        imageMinSize: '600x300',
        isRequired: true,
    },
    {
        type: 'checkbox',
        name: 'is_important',
        label: 'Приоритетный баннер',
    },
];

export default function BannerRightVKP({ project }) {
    return (
        <Pocket
            type="banner_right"
            project={project}
            requiredFields={[]}
            columnsArray={COLUMNS}
            formFields={FORM_FIELDS}
        />
    );
}
